<template>
    <div class="container">
        <b-container fluid v-if="!showPage">
              <b-row>
                <div class="text-center m-5">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>&nbsp;Loading...</strong>
                </div>
              </b-row>
        </b-container>   
        <b-container fluid v-if="showPage" style="margin-top:100px;">            
            <b-row style="text-align: left;">
                <b-col>
                    <br>
                    <h3>PC ID:{{this.clustId}}</h3>
                    <hr>
                </b-col>
            </b-row>                        
            <br/>
            <b-row style="text-align: left;">
                <b-col>
                    
                    <h4>Associated Proteins</h4>
                </b-col>
            </b-row>
            <b-row style="text-align: left;">
                <b-col>
                    <hr>
                    <p><download-csv
                            :data   = "prot_tab_data" style="cursor: pointer;">
                        To download the Proteins data for this cluster <span style="color:red;font-weight: bold;"> {{clustId}} </span> in CSV format: &nbsp;
                        <font-awesome-icon icon="download" ></font-awesome-icon>
                        </download-csv></p>
                </b-col>
            </b-row>
            <b-row style="text-align: left;">
                <b-col>
                    <b-row>
                        <b-col style="align:left">                       
                                <b-input-group>
                                    <b-form-input
                                    v-model="protfilter"
                                    type="search"
                                    id="filterHmPairs"
                                    placeholder="Type to Search"
                                    ></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!protfilter" @click="protfilter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                        </b-col>
                    </b-row>
                    <!-- <b-row style="align:left">
                        <b-col>
                        <b-form-group 
                            label="Filter options"
                            label-for="filt-input">
                            <b-input-group>
                                <b-form-select v-model="filtMod" :options="filtOptions"></b-form-select>
                                <b-form-input id="filt-input" v-model="filtTerm"></b-form-input>
                                <b-button variant="outline-primary" @click="addFilter">Add</b-button>
                            </b-input-group>
                            </b-form-group>
                            <div class="d-inline-block">                            
                            <ul>
                                <li v-for="(btn, idx) in addedFilters"
                                :key="idx" class="listyle">{{filtMap[btn.split(':')[0]]+':'+btn.split(':')[1]}} <a @click="removeFilter(btn)"><font-awesome-icon icon="window-close" size='sm'></font-awesome-icon></a> </li>
                            </ul>
                            </div>
                            <p>
                                <b>Note:</b>
                                The search box can be used to search eMGE ID, cluster ID of the samples only.
                            </p>
                            <p><download-csv
                            :data   = "procSams" style="cursor: pointer;">
                        To download the filtered table data in CSV format: &nbsp;
                        <font-awesome-icon icon="download" ></font-awesome-icon>
                        </download-csv></p>
                        </b-col>                        
                    </b-row> -->
                </b-col>
            </b-row>
            <br>
            <b-row>
                <b-col align-self="center">
                    <b-table
                                responsive
                                show-empty
                                :busy.sync="protIsBusy"
                                :striped="false"
                                :outlined="true"
                                :items="procProtSams"
                                :fields="prot_tab_fields"
                                :current-page="protCurrentPage"
                                :per-page="perPage"
                                :filter="protfilter"
                            >
                            <template  v-slot:table-busy>
                                      <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                      </div>
                            </template>
                            <template v-slot:cell(function) ="row">
                                    <span v-if="row.item.function != null && row.item.function.length>=1 ">
                                        {{row.item.function}}
                                    </span>
                                    <span v-else>
                                        NA
                                    </span>
                            </template>
                             <template v-slot:cell(annotation_src) ="row">
                                    <span v-if="row.item.annotation_src != null && row.item.annotation_src.length>=1">
                                        {{row.item.annotation_src}} 
                                    </span>
                                    <span v-else>
                                        NA
                                    </span>
                            </template>
                            <template v-slot:cell(download)="row">
                                <a @click="downloadFasta(row)" style="cursor:pointer"><font-awesome-icon icon="download" size='sm'></font-awesome-icon></a>
                            </template>
                    </b-table>
                    <b-row>
                            <b-col md="6" class="my-1">
                                <b-pagination
                                v-model="protCurrentPage"
                                :total-rows="procProtSamsSize"
                                :per-page="perPage"
                                class="my-0"
                                ></b-pagination>
                            </b-col>
                            <b-col md="6" class="my-1">
                                <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                                <b-form-select v-model="perPage" :options="protPageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <br/>
            <b-row style="text-align: left;">
                <b-col>
                    <h4>Associated eMGEs</h4>
                </b-col>
            </b-row>
            <b-row style="text-align: left;">
                <b-col>
                    <hr>
                    <p><download-csv
                            :data   = "mge_tab_data" style="cursor: pointer;">
                        To download the eMGE data for this cluster <span style="color:red;font-weight: bold;"> {{clustId}} </span> in CSV format: &nbsp;
                        <font-awesome-icon icon="download" ></font-awesome-icon>
                        </download-csv></p>
                </b-col>
            </b-row>
            <b-row style="text-align: left;">
                <b-col>
                    <b-row>
                        <b-col style="align:left">                       
                                <b-input-group>
                                    <b-form-input
                                    v-model="mgefilter"
                                    type="search"
                                    id="filterHmPairs"
                                    placeholder="Type to Search"
                                    ></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!mgefilter" @click="mgefilter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                        </b-col>
                    </b-row>
                    <!-- <b-row style="align:left">
                        <b-col>
                        <b-form-group 
                            label="Filter options"
                            label-for="filt-input">
                            <b-input-group>
                                <b-form-select v-model="filtMod" :options="filtOptions"></b-form-select>
                                <b-form-input id="filt-input" v-model="filtTerm"></b-form-input>
                                <b-button variant="outline-primary" @click="addFilter">Add</b-button>
                            </b-input-group>
                            </b-form-group>
                            <div class="d-inline-block">                            
                            <ul>
                                <li v-for="(btn, idx) in addedFilters"
                                :key="idx" class="listyle">{{filtMap[btn.split(':')[0]]+':'+btn.split(':')[1]}} <a @click="removeFilter(btn)"><font-awesome-icon icon="window-close" size='sm'></font-awesome-icon></a> </li>
                            </ul>
                            </div>
                            <p>
                                <b>Note:</b>
                                The search box can be used to search eMGE ID, cluster ID of the samples only.
                            </p>
                            <p><download-csv
                            :data   = "procSams" style="cursor: pointer;">
                        To download the filtered table data in CSV format: &nbsp;
                        <font-awesome-icon icon="download" ></font-awesome-icon>
                        </download-csv></p>
                        </b-col>                        
                    </b-row> -->
                </b-col>
            </b-row>
            <br>
            <b-row>
                <b-col align-self="center">
                    <b-table
                                responsive
                                show-empty
                                :busy.sync="mgeIsBusy"
                                :striped="false"
                                :outlined="true"
                                :items="mgeProcSams"
                                :fields="mge_tab_fields"
                                :current-page="mgeCurrentPage"
                                :per-page="perPage"
                                :filter="mgefilter"
                            >
                            <template  v-slot:table-busy>
                                      <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                      </div>
                            </template>
                            <template v-slot:cell(MGEs_id) ="row">
                                <router-link :to="{ path: '/viewmge/'+row.item.MGEs_id.trim()}" target="_blank">{{row.item.MGEs_id.trim()}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></router-link>
                            </template>
                            <template v-slot:cell(Genome_quality) ="row">
                                    <span v-if="row.item.Genome_quality != null">
                                        {{row.item.Genome_quality}}
                                    </span>
                                    <span v-else>
                                        NA
                                    </span>
                            </template>
                            <template v-slot:cell(MGEs_cluster) ="row">
                                    <span v-if="row.item.MGEs_cluster != 'singlet'">
                                        <router-link :to="{ path: '/viewcluster/'+row.item.MGEs_cluster.trim()}" target="_blank">{{row.item.MGEs_cluster.trim()}} <font-awesome-icon icon="external-link-square-alt" size='sm'></font-awesome-icon></router-link>
                                    </span>
                                    <span v-else>
                                        {{row.item.MGEs_cluster.trim()}}
                                    </span>
                            </template>
                    </b-table>
                    <b-row>
                            <b-col md="6" class="my-1">
                                <b-pagination
                                v-model="mgeCurrentPage"
                                :total-rows="mgeProcSamsSize"
                                :per-page="perPage"
                                class="my-0"
                                ></b-pagination>
                            </b-col>
                            <b-col md="6" class="my-1">
                                <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                                <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import axios from 'axios'
const _ = require("underscore")
const FileSaver = require('file-saver');

export default {
    data () {
        return{
            server_add:"https://mai.fudan.edu.cn/",
            showPage:true,
            filter:null,
            mgefilter:null,
            protfilter:null,
            mgeIsBusy:true,
            protIsBusy:true,
            mge_tab_data:[],
            prot_tab_data:[],
            mge_tab_fields:[
                { key:'MGEs_id',label:'eMGE ID',sortable:false },
                { key: 'status', label: 'Type', sortable: false },
                { key: 'MGEs_cluster', label: 'eMGE cluster', sortable: true},
                { key: 'contig_length', label: 'Length', sortable: true},
                { key: 'structure', label: 'Structure', sortable: true},
                { key: 'Genome_quality', label: 'Quality', sortable: true},
                // { key: 'abundance', label: 'Relative abundance', sortable: true},
            ],
            prot_tab_fields:[
                { key:'genProteinId',label:'Protein ID',sortable:false },
                { key:'function',label:'Function',sortable:false },
                { key:'annotation_src',label:'Annotation source',sortable:false },
                { key:'download',label:'',sortable:false }
            ],
            totalRows: 1,
            mgeCurrentPage: 1,
            protCurrentPage:1,
            perPage: 5,
            protPageOptions: [5, 10, 15,25],
            pageOptions: [5, 10, 15,25],
            projHtmlTxt:'',
            filtMod:'Country',
            filtTerm:'',
            filtOptions:['Country','Related disease'],
            filtMap:{'Country':'Country','RelatedDisease':'Related disease','Related disease':'RelatedDisease'},
            addedFilters:[],
            clustId:'',
        }
    },
    mounted() {
        let clustId = this.$route.params.clustid
        if(clustId != undefined){
            this.clustId = clustId
            this.loadProtDat()
            this.loadMgeDat()
        }
        // this.loadProjTab()
    },
    computed: {
        mgeProcSams(){
            if(this.mge_tab_data.length){
                let tem = this.mge_tab_data.filter(sam =>{
                    var hasAss = false
                    if(this.mgefilter != null && this.mgefilter.length>=1){
                        // console.log(filter)
                        var sup = this.mgefilter                                        
                        if( (sam.NCBIProjectID != null && sam.NCBIProjectID.match(sup)) || 
                            (sam.Country != null && sam.Country.match(sup)) || 
                            (sam.RelatedDisease != null && sam.RelatedDisease.match(sup)) ){
                            hasAss = true
                        }
                    }else{
                        hasAss = true
                    }
                    if(this.addedFilters.length>=1){
                        var su = 0
                        this.addedFilters.forEach(ele => {
                            var sp = ele.split(':')
                            if(sp != null  && sam[sp[0]] != null && sam[sp[0]].toLowerCase().match(sp[1].toLowerCase())){
                               su++ 
                            }
                        });
                        return hasAss && su === this.addedFilters.length
                    }else{
                        return hasAss && true
                    }
                })
                return tem
            }
            return null
        },
        mgeProcSamsSize(){
            if(this.mge_tab_data.length){
                let tem = this.mge_tab_data.filter(sam =>{
                    var hasAss = false
                    if(this.mgefilter != null && this.mgefilter.length>=1){
                        // console.log(filter)
                        var sup = this.mgefilter                                        
                        if( (sam.NCBIProjectID != null && sam.NCBIProjectID.match(sup)) || 
                            (sam.Country != null && sam.Country.match(sup)) || 
                            (sam.RelatedDisease != null && sam.RelatedDisease.match(sup)) ){
                            hasAss = true
                        }
                    }else{
                        hasAss = true
                    }
                    if(this.addedFilters.length>=1){
                        var su = 0
                        this.addedFilters.forEach(ele => {
                            var sp = ele.split(':')
                            if(sp != null  && sam[sp[0]] != null && sam[sp[0]].toLowerCase().match(sp[1].toLowerCase())){
                               su++ 
                            }
                        });
                        return hasAss && su === this.addedFilters.length
                    }else{
                        return hasAss && true
                    }
                })
                return tem.length
            }
            return 0
        },
        procProtSams(){
            if(this.prot_tab_data.length){
                let tem = this.prot_tab_data.filter(sam =>{
                    var hasAss = false
                    if(this.protfilter != null && this.protfilter.length>=1){
                        // console.log(filter)
                        var sup = this.protfilter                                        
                        if( (sam.NCBIProjectID != null && sam.NCBIProjectID.match(sup)) || 
                            (sam.Country != null && sam.Country.match(sup)) || 
                            (sam.RelatedDisease != null && sam.RelatedDisease.match(sup)) ){
                            hasAss = true
                        }
                    }else{
                        hasAss = true
                    }
                    if(this.addedFilters.length>=1){
                        var su = 0
                        this.addedFilters.forEach(ele => {
                            var sp = ele.split(':')
                            if(sp != null  && sam[sp[0]] != null && sam[sp[0]].toLowerCase().match(sp[1].toLowerCase())){
                               su++ 
                            }
                        });
                        return hasAss && su === this.addedFilters.length
                    }else{
                        return hasAss && true
                    }
                })
                return tem
            }
            return null
        },
        procProtSamsSize(){
            if(this.prot_tab_data.length){
                let tem = this.prot_tab_data.filter(sam =>{
                    var hasAss = false
                    if(this.protfilter != null && this.protfilter.length>=1){
                        // console.log(filter)
                        var sup = this.protfilter                                        
                        if( (sam.NCBIProjectID != null && sam.NCBIProjectID.match(sup)) || 
                            (sam.Country != null && sam.Country.match(sup)) || 
                            (sam.RelatedDisease != null && sam.RelatedDisease.match(sup)) ){
                            hasAss = true
                        }
                    }else{
                        hasAss = true
                    }
                    if(this.addedFilters.length>=1){
                        var su = 0
                        this.addedFilters.forEach(ele => {
                            var sp = ele.split(':')
                            if(sp != null  && sam[sp[0]] != null && sam[sp[0]].toLowerCase().match(sp[1].toLowerCase())){
                               su++ 
                            }
                        });
                        return hasAss && su === this.addedFilters.length
                    }else{
                        return hasAss && true
                    }
                })
                return tem.length
            }
            return 0
        }
    },
    methods: {
        loadMgeDat(){
            axios.post(this.server_add+'query/listMGEForProtclustBig',
            {
                clustid: this.clustId
            }).then(retDat => {
                if(retDat.status == 200){
                    this.mge_tab_data = retDat.data
                    this.showPage = true
                    this.mgeIsBusy = false
                }
            }).catch(err => {
                console.log(err)
            })
        },
        filterTable(row,filter) {
            var hasAss = false
            if(filter.includes(row.NCBIProjectID) || filter.includes(row.Country) || filter.includes(row.RelatedDisease)){
                hasAss = true
            }
            if(filter != null ){
                var su = filter.trim()
                if( (row.NCBIProjectID != null && row.NCBIProjectID.match(su)) || 
                (row.Country != null && row.Country.match(su)) || 
                (row.RelatedDisease != null && row.RelatedDisease.match(su)) ){
                  hasAss = true
                }
            }
            return hasAss;            
        },
        loadProtDat(){
            axios.post(this.server_add+'query/getProtPartners',
            {
                clustid:this.clustId
            },{ timeout: 320000}).then(retDat => {                
                if(retDat.status == 200){
                    this.prot_tab_data = retDat.data
                    this.showPage = true
                    this.protIsBusy = false
                }
            }).catch(err => {
                console.log(err)
            })
        },
        downloadFasta(rowDat){
            var fas = '>'+rowDat.item.prot_id+'\n'+rowDat.item.sequence
            var file = new File([fas], rowDat.item.prot_id+'.fasta', {type: "text/plain;charset=utf-8"});
            FileSaver.saveAs(file);
        },
        addFilter(){
            var filtType = this.filtMap[this.filtMod]
            var filtText = this.filtTerm
            var res = filtType+":"+filtText
            if(!this.addedFilters.includes(res)){
                this.addedFilters.push(res)
                this.filtTerm = ''
            }
        },
        removeFilter(term){
            var ind = this.addedFilters.indexOf(term)
            if(ind >-1){
                this.addedFilters.splice(ind, 1);
            }
        },
    },
}
</script>

<style lang="less">
    #boxBg{
    background-color: #ECE9E9;
    padding-top: 10px;
    padding-bottom: 5px;
    padding-left: 5px;
    align-content: left;
    color: black;
}

.medium_col{
  width: 160px !important;
  height: 25px !important;
  max-height: 25px !important;
  max-width: 160px !important;
  text-align: center;
}
</style>